<template>
  <div :id="content.key" class="front-container">
    <template v-for="(item, index) in content.content">
      <frontCover :key="index" v-if="item.type === 'frontCover'" :content="item"></frontCover>
      <title1 :key="index" v-if="item.type === 'title-1'" :content="item"></title1>
      <title2 :key="index" v-if="item.type === 'title-2'" :content="item"></title2>
      <timeLine :key="index" v-if="item.type === 'timeLine'" :content="item"></timeLine>
      <textIndex :key="index" v-if="item.type === 'text'" :content="item"></textIndex>
      
    </template>
  </div>
</template>
<script>
/*
首页
*/
import frontCover from "./frontCover.vue";
import title1 from "./title-1.vue";
import title2 from "./title-2.vue";
import timeLine from "./timeLine.vue";
import textIndex from "./text/index.vue";
export default {
  name: "frontPage",
  components: {
    frontCover,
    title1,
    title2,
    timeLine,
    textIndex,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
}
</script>

<style lang="scss" scoped>
p{
  img{
    max-width: 100%;
    display: block;
  }
}
</style>